/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type BillingGroupTypeEnum = "Manual" | "SSO" | "%future added value";
export type InvitePolicyEnum = "AdminOnly" | "AnyMember" | "%future added value";
export type ProductTypeEnum = "Business_NonStandard" | "Business_Standard" | "Enterprise_NonStandard" | "Enterprise_Standard" | "Pro_NonStandard" | "Pro_Standard" | "%future added value";
export type SearchPersonStatusResponse = "Deactivated" | "Invited" | "NonUser" | "User" | "%future added value";
export type SuggestedOrgInviteReason = "AttendSameMeetings" | "MeetsWithYourTeammates" | "OnYourTeam" | "OrganizedYourMeetings" | "%future added value";
export type SuggestedOrgInviteResolution = "Accepted" | "Dismissed" | "%future added value";
export type AdminPanelBillingGroupsMembers_org = {
    readonly id: string;
    readonly orgPersonListPaginatedErrorable: {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
    } | {
        readonly __typename: "OrgPersonListPaginated";
        readonly inputQuery: string | null;
        readonly nextPersonId: string | null;
        readonly previousPersonId: string | null;
        readonly searchPersons: ReadonlyArray<{
            readonly person: {
                readonly primaryCalendarId: string;
                readonly userId: string | null;
                readonly personId: string;
                readonly signUpMillis: unknown | null;
                readonly isYou: boolean;
                readonly primaryBillingGroupIdErrorable: ({
                    readonly __typename: "PrimaryBillingGroupId";
                    readonly primaryBillingGroupId: string | null;
                } | {
                    readonly __typename: "GraphEntityError";
                    readonly message: string | null;
                    readonly statusCode: number | null;
                } | {
                    /*This will never be '%other', but we need some
                    value in case none of the concrete values match.*/
                    readonly __typename: "%other";
                }) | null;
                readonly profile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                    readonly externalImageUrl: string | null;
                } | null;
            };
            readonly status: SearchPersonStatusResponse;
        }> | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly suggestedInvites: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly targetCalendarId: string | null;
                readonly targetProfile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                    readonly externalImageUrl: string | null;
                } | null;
                readonly resolution: SuggestedOrgInviteResolution | null;
                readonly numberOfSharedMeetings: number | null;
                readonly numberOfOrganizedMeetings: number | null;
                readonly inviteReason: SuggestedOrgInviteReason | null;
                readonly totalScore: number | null;
            } | null;
        } | null> | null;
    } | null;
    readonly teamsForOrg: {
        readonly __typename: "TeamList";
        readonly list: ReadonlyArray<{
            readonly teamId: string;
            readonly teamName: string;
        }>;
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly billingGroups: {
        readonly list?: ReadonlyArray<{
            readonly id: string;
            readonly name: string;
            readonly createdAtMillis: unknown;
            readonly invitePolicy: InvitePolicyEnum;
            readonly type: BillingGroupTypeEnum | null;
            readonly dsyncConfigured: ({
                readonly __typename: "DsyncConfigured";
                readonly isDsyncConfigured: boolean;
            } | {
                readonly __typename: "GraphEntityError";
                readonly statusCode: number | null;
                readonly message: string | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            }) | null;
            readonly personListPaginatedErrorable: ({
                readonly __typename: "GraphEntityError";
                readonly message: string | null;
            } | {
                readonly __typename: "OrgPersonListPaginated";
                readonly count: number | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            }) | null;
            readonly manualMembers: {
                readonly __typename: "BillingGroupManualMemberList";
                readonly list: ReadonlyArray<{
                    readonly externalUserId: string;
                    readonly calendarId: string;
                    readonly userId: string | null;
                    readonly personId: string | null;
                    readonly orgPerson: ({
                        readonly __typename: "OrgPerson";
                        readonly userId: string | null;
                        readonly personId: string;
                        readonly primaryCalendarId: string;
                        readonly isYou: boolean;
                        readonly signUpMillis: unknown | null;
                        readonly profile: {
                            readonly givenName: string | null;
                            readonly familyName: string | null;
                        } | null;
                    } | {
                        readonly __typename: "GraphEntityError";
                        readonly message: string | null;
                        readonly statusCode: number | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    }) | null;
                }>;
            } | {
                readonly __typename: "GraphEntityError";
                readonly message: string | null;
                readonly statusCode: number | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
            readonly adminOrgPersons: {
                readonly __typename: "OrgPersonList";
                readonly list: ReadonlyArray<{
                    readonly userId: string | null;
                    readonly personId: string;
                    readonly primaryCalendarId: string;
                    readonly isYou: boolean;
                    readonly signUpMillis: unknown | null;
                    readonly profile: {
                        readonly givenName: string | null;
                        readonly familyName: string | null;
                    } | null;
                }>;
            } | {
                readonly __typename: "GraphEntityError";
                readonly message: string | null;
                readonly statusCode: number | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
            readonly subscription: {
                readonly __typename: "SubscriptionDetails";
                readonly subscription: {
                    readonly id: string;
                    readonly productType: ProductTypeEnum | null;
                    readonly seatCount: number;
                };
            } | {
                readonly __typename: "GraphEntityError";
                readonly message: string | null;
                readonly statusCode: number | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
        }> | undefined;
        readonly message?: string | null | undefined;
        readonly statusCode?: number | null | undefined;
    };
    readonly " $fragmentRefs": FragmentRefs<"OrgInvite_org" | "AdminSelect_org">;
    readonly " $refType": "AdminPanelBillingGroupsMembers_org";
};
export type AdminPanelBillingGroupsMembers_org$data = AdminPanelBillingGroupsMembers_org;
export type AdminPanelBillingGroupsMembers_org$key = {
    readonly " $data"?: AdminPanelBillingGroupsMembers_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AdminPanelBillingGroupsMembers_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = [
        {
            "kind": "Variable",
            "name": "activityFilter",
            "variableName": "activityFilter"
        } as any,
        {
            "kind": "Variable",
            "name": "billingGroupId",
            "variableName": "billingGroupId"
        } as any,
        {
            "kind": "Variable",
            "name": "fetchNext",
            "variableName": "fetchNext"
        } as any,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        } as any,
        {
            "kind": "Variable",
            "name": "pageToken",
            "variableName": "pageToken"
        } as any,
        {
            "kind": "Variable",
            "name": "searchQuery",
            "variableName": "searchQuery"
        } as any,
        {
            "kind": "Variable",
            "name": "sortDirection",
            "variableName": "sortDirection"
        } as any,
        {
            "kind": "Variable",
            "name": "sortType",
            "variableName": "sortType"
        } as any,
        {
            "kind": "Variable",
            "name": "teamId",
            "variableName": "teamId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v4 = {
        "kind": "InlineFragment",
        "selections": [
            (v3 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryCalendarId",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signUpMillis",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v11 = {
        "kind": "InlineFragment",
        "selections": [
            (v3 /*: any*/),
            (v10 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "givenName",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "familyName",
        "storageKey": null
    } as any, v14 = [
        (v12 /*: any*/),
        (v13 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalImageUrl",
            "storageKey": null
        } as any
    ], v15 = {
        "kind": "InlineFragment",
        "selections": [
            (v10 /*: any*/),
            (v3 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v16 = [
        (v6 /*: any*/),
        (v7 /*: any*/),
        (v5 /*: any*/),
        (v9 /*: any*/),
        (v8 /*: any*/),
        {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
                (v12 /*: any*/),
                (v13 /*: any*/)
            ],
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "activityFilter"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "billingGroupId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "fetchNext"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "limit"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "pageToken"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "searchQuery"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "sortDirection"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "sortType"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "teamId"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "AdminPanelBillingGroupsMembers_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": (v1 /*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "orgPersonListPaginatedErrorable",
                "plural": false,
                "selections": [
                    (v2 /*: any*/),
                    (v4 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "inputQuery",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "nextPersonId",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "previousPersonId",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SearchPerson",
                                "kind": "LinkedField",
                                "name": "searchPersons",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrgPerson",
                                        "kind": "LinkedField",
                                        "name": "person",
                                        "plural": false,
                                        "selections": [
                                            (v5 /*: any*/),
                                            (v6 /*: any*/),
                                            (v7 /*: any*/),
                                            (v8 /*: any*/),
                                            (v9 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "primaryBillingGroupIdErrorable",
                                                "plural": false,
                                                "selections": [
                                                    (v2 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "primaryBillingGroupId",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "PrimaryBillingGroupId",
                                                        "abstractKey": null
                                                    },
                                                    (v11 /*: any*/)
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "UserProfile",
                                                "kind": "LinkedField",
                                                "name": "profile",
                                                "plural": false,
                                                "selections": (v14 /*: any*/),
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "status",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "OrgPersonListPaginated",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000000
                    }
                ],
                "concreteType": "SuggestedOrgInviteConnection",
                "kind": "LinkedField",
                "name": "suggestedInvites",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SuggestedOrgInviteEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SuggestedOrgInvite",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "targetCalendarId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "UserProfile",
                                        "kind": "LinkedField",
                                        "name": "targetProfile",
                                        "plural": false,
                                        "selections": (v14 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "resolution",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "numberOfSharedMeetings",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "numberOfOrganizedMeetings",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "inviteReason",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "totalScore",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": "suggestedInvites(first:1000000)"
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "teamsForOrg",
                "plural": false,
                "selections": [
                    (v2 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamName",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "TeamList",
                        "abstractKey": null
                    },
                    (v15 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "billingGroups",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "BillingGroup",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "createdAtMillis",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "invitePolicy",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "type",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "dsyncConfigured",
                                        "plural": false,
                                        "selections": [
                                            (v2 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "isDsyncConfigured",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "DsyncConfigured",
                                                "abstractKey": null
                                            },
                                            (v15 /*: any*/)
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "personListPaginatedErrorable",
                                        "plural": false,
                                        "selections": [
                                            (v2 /*: any*/),
                                            (v4 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "count",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "OrgPersonListPaginated",
                                                "abstractKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "manualMembers",
                                        "plural": false,
                                        "selections": [
                                            (v2 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "BillingGroupManualMember",
                                                        "kind": "LinkedField",
                                                        "name": "list",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "externalUserId",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "calendarId",
                                                                "storageKey": null
                                                            },
                                                            (v6 /*: any*/),
                                                            (v7 /*: any*/),
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": null,
                                                                "kind": "LinkedField",
                                                                "name": "orgPerson",
                                                                "plural": false,
                                                                "selections": [
                                                                    (v2 /*: any*/),
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": (v16 /*: any*/),
                                                                        "type": "OrgPerson",
                                                                        "abstractKey": null
                                                                    },
                                                                    (v11 /*: any*/)
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "BillingGroupManualMemberList",
                                                "abstractKey": null
                                            },
                                            (v11 /*: any*/)
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "adminOrgPersons",
                                        "plural": false,
                                        "selections": [
                                            (v2 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "OrgPerson",
                                                        "kind": "LinkedField",
                                                        "name": "list",
                                                        "plural": true,
                                                        "selections": (v16 /*: any*/),
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "OrgPersonList",
                                                "abstractKey": null
                                            },
                                            (v11 /*: any*/)
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "subscription",
                                        "plural": false,
                                        "selections": [
                                            (v2 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "PaymentSubscription",
                                                        "kind": "LinkedField",
                                                        "name": "subscription",
                                                        "plural": false,
                                                        "selections": [
                                                            (v0 /*: any*/),
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "productType",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "seatCount",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "SubscriptionDetails",
                                                "abstractKey": null
                                            },
                                            (v11 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "BillingGroupList",
                        "abstractKey": null
                    },
                    (v11 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OrgInvite_org"
            },
            {
                "args": (v1 /*: any*/),
                "kind": "FragmentSpread",
                "name": "AdminSelect_org"
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'c27d9b6dd3affbd70002fbea91418670';
export default node;
